import { createIcon } from './factory'
import Bold from './x.bold.svg?react'
import Duotone from './x.duotone.svg?react'
import Fill from './x.fill.svg?react'
import Regular from './x.regular.svg?react'

export const X = createIcon({ regular: Regular, bold: Bold, fill: Fill, duotone: Duotone })
